import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
	selector: 'app-side-menu',
	templateUrl: './side-menu.component.html',
	styleUrls: ['./side-menu.component.scss'],
})
export class SideMenuComponent implements OnInit {
	@Input() options: any[];
	@Output() tab = new EventEmitter<string>();
	public activeTab: string;

	constructor() {}

	ngOnInit(): void {
		this.activeTab = this.options[0].tab_name;
	}

	selectTab(tab: string) {
		this.activeTab = tab;
		this.tab.emit(tab);
	}
}
